import { DraftedPlayerInfo, DraftedPlayerResponse } from '@pff-consumer/schema'
import { extractId } from '@pff-consumer/utils'

// This function is used in the MDS results page.
// The results API gives player ID and some fields like pickGrade, overallGrade etc.,
// The remaining details of the player like first name, last name, position etc., will have to be fetched from playerInfoMap
// and merged into one DraftedPlayerInfo[] object.

export const mergeDraftedPlayerInfo = (
  draftedPlayers: DraftedPlayerResponse[],
  selectedTeamPlayerInfo: Record<string, Partial<DraftedPlayerInfo>>,
  leagueKeepers: number[]
): DraftedPlayerInfo[] => {
  const mergedDraftedPlayerInfo: DraftedPlayerInfo[] = draftedPlayers.map((playerWithPickGrade) => {
    const playerInfo = selectedTeamPlayerInfo[playerWithPickGrade.id]
    const playerId = extractId(playerWithPickGrade.id)
    return {
      id: playerId,
      firstName: playerInfo.firstName,
      lastName: playerInfo.lastName,
      team: playerInfo.team,
      position: playerInfo.position,
      teamCity: playerInfo.teamCity,
      teamName: playerInfo.teamName,
      bye: playerInfo.bye,
      draftPick: playerWithPickGrade.draftPick,
      fantasyTeamId: playerWithPickGrade.fantasyTeamId,
      pickGradeLetter: playerWithPickGrade.pickGradeLetter,
      isKeeper: leagueKeepers.includes(playerId),
    }
  }) as DraftedPlayerInfo[]

  return mergedDraftedPlayerInfo
}
